/*
 * 5-М4 «Мои клиенты». Размеры из макета «Мастер - П0»: поиск 48 px, строка клиента
 * не ниже 56 px, аватар 36 с инициалами, кнопка звонка 44×44.
 */

.searchRow {
  flex: none;
  padding: var(--space-1) var(--space-4) var(--space-2);
}

.search {
  width: 100%;
  height: var(--touch-min-target);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-strong);
  background: var(--bg-card);
  color: var(--text-primary);
  font: inherit;
  font-size: var(--font-size-lg);
  padding: 0 12px;
}

.search:focus-visible {
  outline: none;
  border-color: var(--accent);
  box-shadow: var(--field-focus-ring);
}

.list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 var(--space-4) var(--space-2);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3) 0;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.groupTitle {
  margin: var(--space-2) 0 0;
  font-size: var(--font-size-xs-plus);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: var(--font-weight-semibold);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 56px;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--bg-card);
}

.avatar {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 50%;
  background: var(--bg-sunken);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

/* Текст занимает всё свободное место, поэтому метка и кнопка звонка прижимаются
   вправо сами — без margin-left: auto на каждой из них. Иначе при обеих между ними
   появлялся бы провал в полстроки. */
.rowText {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.rowName {
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-base);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowSub {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.noShow {
  flex: none;
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-semibold);
  color: var(--status-no-show-fg);
}

.call {
  flex: none;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  color: var(--text-primary);
  text-decoration: none;
  font-size: var(--font-size-lg);
}

.call:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

.footNote {
  margin: var(--space-2) 0 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.4;
}
